import { useState } from "react";
import ToggleSwitch from "./basicComponents/switch-box";

interface ReleaseButtonProps {
  rowId: string;
}

export default function ReleaseButton({ rowId }: ReleaseButtonProps) {
  const [isToggled, setIsToggled] = useState(false);

  const handleToggle = () => {
    setIsToggled(!isToggled);
    console.log("تست", rowId);
  };

  return <ToggleSwitch label="" onChange={handleToggle} checked={isToggled} />;
}
